<mat-card class="import-dialog">
  <div class="dialog-header header">
    <h1 class="header-title">{{ dialogData.caption }}</h1>
    <button mat-icon-button aria-label="Close dialog" class="close-button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-card-content class="file-input-section">
    <div class="file-upload-button-row">
    <!-- File input section -->
    <div >
      <input type="file" id="fileUpload" accept=".csv,.xlsx,.xls" 
      (change)="((dialogData?.response?.SubGroup1 == 'HOMEAUDIT' || dialogData?.response?.SubGroup == 'REBATE') && 
      dialogData?.response?.SectionInfo[8]?.ImportEnabled === 1) ? onFileChange($event) : handleFileSelection($event)"
        name="uploadExcel" aria-label="Upload Excel or CSV file" />
      <label for="fileUpload" class="file-input-label">
        <mat-icon>cloud_upload</mat-icon>
        Choose File
      </label>
    </div>

    <!-- Template download link -->
    <button (click)="downloadImportTemplate()" class="template-link" mat-stroked-button color="accent">
      <mat-icon *ngIf="!isDownloadFile">download</mat-icon>
      <mat-spinner *ngIf="isDownloadFile" diameter="20"></mat-spinner>
      <span>Download Template</span>
      <!-- Loader -->
    </button>
  </div>
  <div class="file-name" *ngIf="selectedFile">
        {{ selectedFile.name }}
  </div>
  </mat-card-content>

  <!-- Card actions -->
  <mat-card-actions class="card-actions">
    <button mat-raised-button color="primary" (click)="((dialogData?.response?.SubGroup1 == 'HOMEAUDIT' || dialogData?.response?.SubGroup == 'REBATE') && 
      dialogData?.response?.SectionInfo[8]?.ImportEnabled === 1) ? workSheetUploadDocument() : uploadDocument()" [disabled]="!selectedFile || isUploading"
      aria-label="Upload selected file">
      <mat-spinner diameter="20" *ngIf="isUploading"></mat-spinner>
      <span *ngIf="!isUploading">Upload</span>
    </button>
  </mat-card-actions>
</mat-card>